module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step3-1-p-4476e3e6737d4e49c2c218378fa13140.gif";